var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInputCheckmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1.0477,
    width: 16,
    height: 16,
    rx: 8,
    stroke: "#35C7FF",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.0911 6.87131L7.27296 12.9048L4.09106 9.60514L5.30728 8.32422L7.27296 10.3669L13.0911 4.3334L13.0911 6.87131Z",
    fill: "#35C7FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInputCheckmark);
export default __webpack_public_path__ + "static/media/input-checkmark.c28473b4396e6358dea599f719016602.svg";
export { ForwardRef as ReactComponent };